import { IBH_PRODUCTS_PER_PAGE } from '@hub/libs/constants';
import { IbhProductTile } from '@hub/bearing-hub/BearingHubPage/BearingsTable/ProductTile';
import { ProductSort } from '@hub/bearing-hub/BearingHubPage/BearingsTable/ProductSort';
import type { ShapeDescriptor } from '@hub/bearing-hub/common/shapes/shapes';
import type { IbhPartsResponseDto } from '@igus/iglidur-bearing-hub-api';
import { QuantityInput } from '@hub/bearing-hub/BearingHubPage/QuantityInput';
import type { IbhPartsLifetimeResponseDto } from '@igus/iglidur-bearing-hub-api/src/data-contracts';
import type { UnitSystem } from '@igus/kopla-domain';

export interface ProductTileListProps {
  currentPage: number;
  maxLifeTimeReference: number;
  lastKnownValidResponse: IbhPartsResponseDto[];
  quantityInputValue: number;
  selectedShape: ShapeDescriptor;
  unitSystem: UnitSystem;
  clientReady: boolean;
  bearingPartsLifetime: IbhPartsLifetimeResponseDto;
  isLifetimeLoading: boolean;
  onQuantityChange: (value?: number) => void;
  setActiveModal?: (state: boolean) => void;
}

export const ProductTileList = ({
  currentPage,
  maxLifeTimeReference,
  lastKnownValidResponse,
  quantityInputValue,
  selectedShape,
  setActiveModal,
  unitSystem,
  clientReady,
  bearingPartsLifetime,
  isLifetimeLoading,
  onQuantityChange,
}: ProductTileListProps) => (
  <>
    <div className="grid grid-cols-5 gap-4 items-center">
      <div className="col-span-2 mb-[15px]">
        <QuantityInput initialQuantity={quantityInputValue} onQuantityChange={onQuantityChange} />
      </div>
      {clientReady && (
        <div className="col-span-3">
          <ProductSort />
        </div>
      )}
    </div>
    <>
      {lastKnownValidResponse
        .slice(IBH_PRODUCTS_PER_PAGE * (currentPage - 1), IBH_PRODUCTS_PER_PAGE * currentPage)
        .map(product => (
          <IbhProductTile
            key={product.articleNumber}
            data={product}
            maxLifeTimeReference={maxLifeTimeReference}
            isCustom={product.articleNumber.startsWith('TEMP-')}
            quantity={quantityInputValue}
            selectedShape={selectedShape}
            setActiveModal={setActiveModal}
            lifetime={bearingPartsLifetime?.lifetimes?.[product.articleNumber]}
            isLifetimeLoading={isLifetimeLoading}
            unitSystem={unitSystem}
            clientReady={clientReady}
          />
        ))}
    </>
  </>
);
